module.exports = __webpack_public_path__ + "media/images/landing_page/digweddash3-064a0a063953cce8743a71e0cc4b0b20.png";